import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { server } from "../server";

// Async thunk for fetching events
export const fetchEventsByUserId = createAsyncThunk(
  "events/fetchByUserId",
  async (userId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(
        `${server}/Event/GetEventByUserObjectId?userObjectId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      const data = await res.json();
      if (!res.ok) {
        return rejectWithValue(data.message || "Failed to fetch events");
      }

      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const eventSlice = createSlice({
  name: "events",
  initialState: {
    events: [],
    totalUploadedImages: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventsByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventsByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload.events || [];
        state.totalUploadedImages = action.payload.totalUploadedImages || 0;
      })
      .addCase(fetchEventsByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default eventSlice.reducer;
